export default __webpack_public_path__ + "media/fonts/GTWalsheim/gt-walsheim-web-5b202f841ce5d8e26bca0e8e35af01fe.ttf";